import script from "./WhyLinuxView.vue?vue&type=script&setup=true&lang=ts"
export * from "./WhyLinuxView.vue?vue&type=script&setup=true&lang=ts"

import "./WhyLinuxView.vue?vue&type=style&index=0&id=cfd6b8da&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cfd6b8da"]])

export default __exports__